// Enum for table columns (API response fields)
export enum OrderTableColumn {
  CREATED_DATE = "created_date",
  ORDER_NO = "order_no",
  SALES_LEAD_ID = "sales_lead_id",
  COMPANY_NAME = "company_name",
  LEAD_NAME = "lead_name",
  ENQUIRY_CATEGORY_NAME = "enquiry_category_name",
  ADVANCE_RECEIVED_AMOUNT = "advance_received_amount",
  ORDER_STATUS_NAME = "order_status_name",
}

// Enum for export columns (backend expected fields)
export enum OrderExportColumn {
  CREATED_DATE = "created_date",
  ORDER_NO = "order_no",
  SALES_LEAD_ID = "sales_lead_id",
  COMPANY_NAME = "company_name",
  LEAD_NAME = "lead_name",
  ENQUIRY_CATEGORY_NAME = "enquiry_category_name",
  ADVANCE_RECEIVED_AMOUNT = "advance_received_amount",
  ORDER_STATUS_NAME = "order_status_name",
}

// Column display names mapping (for UI)
export const OrderColumnLabels: Record<OrderTableColumn, string> = {
  [OrderTableColumn.CREATED_DATE]: "Date",
  [OrderTableColumn.ORDER_NO]: "Order No.",
  [OrderTableColumn.SALES_LEAD_ID]: "Code",
  [OrderTableColumn.COMPANY_NAME]: "Company",
  [OrderTableColumn.LEAD_NAME]: "Lead Name",
  [OrderTableColumn.ENQUIRY_CATEGORY_NAME]: "Enquiry Category",
  [OrderTableColumn.ADVANCE_RECEIVED_AMOUNT]: "Advance Received",
  [OrderTableColumn.ORDER_STATUS_NAME]: "Status",
};

// Default selected columns for export (all true)
export const getDefaultOrderSelectedColumns = () => ({
  [OrderExportColumn.CREATED_DATE]: true,
  [OrderExportColumn.ORDER_NO]: true,
  [OrderExportColumn.SALES_LEAD_ID]: true,
  [OrderExportColumn.COMPANY_NAME]: true,
  [OrderExportColumn.LEAD_NAME]: true,
  [OrderExportColumn.ENQUIRY_CATEGORY_NAME]: true,
  [OrderExportColumn.ADVANCE_RECEIVED_AMOUNT]: true,
  [OrderExportColumn.ORDER_STATUS_NAME]: true,
});
